// <product-gallery>: photo slides plus a "Your design" slide drawn live from the configurator.
// Switches to the preview the moment a shopper personalises, and back via the toggle or thumbnails.

import { bubbleSvg } from '@theme/bubble';
import { $, $$ } from '@theme/utils';

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.stage = $('.stage', this);
    this.preview = $('[data-preview-slide]', this);
    this.design = {};
    this.addEventListener('click', this.onClick);
    const scope = this.closest('.shopify-section') || document;
    scope.addEventListener('design:change', (event) => this.onDesign(event.detail));
    const configurator = scope.querySelector('product-configurator');
    if (configurator?.design) this.onDesign({ ...configurator.design, source: 'initial' });
  }

  onClick = (event) => {
    const target = event.target.closest('[data-show]');
    if (target) this.show(target.dataset.show);
  };

  onDesign(design) {
    this.design = design;
    if (!this.preview) return;
    this.preview.innerHTML = bubbleSvg(design);
    $$('[data-preview-thumb]', this).forEach((thumb) => { thumb.innerHTML = bubbleSvg({ ...design, placeholder: '' }); });
    if (design.source === 'option') this.show('preview');
    else if (design.variantImage && this.current !== 'preview') this.show(String(design.variantImage));
  }

  show(id) {
    const slides = $$('.stage__slide', this);
    const target = slides.find((s) => s.dataset.slide === id) || slides[0];
    if (!target) return;
    this.current = target.dataset.slide;
    slides.forEach((s) => s.classList.toggle('is-active', s === target));
    this.stage.classList.toggle('is-preview', this.current === 'preview');
    $$('[data-show]', this).forEach((b) => {
      const active = b.dataset.show === this.current || (b.dataset.show === 'photo' && this.current !== 'preview');
      b.setAttribute(b.closest('.view-toggle') ? 'aria-pressed' : 'aria-current', String(active));
    });
  }
}

customElements.define('product-gallery', ProductGallery);
